﻿$.fn.dxCtrlChartHistoVue = function custom_dxCtrlChartHistoVue(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcharthistovue dx-ctrl");
        this.createInstance(new cdxCtrlChartHistoVue(this, option));
    }
    return this;
}

window.cdxCtrlChartHistoVue = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.context_grid == 'undefined') option.context_grid = "datacharthistovue"

    function mConstruit() {
        container.empty()
        container.css({ "height": "100%", "width": "100%" })
        Me.mUpdate()
    }

    var dxChart = null
    var dxZoom = null
    var oldDs = null
    function mRempli(ds, maxDate) {
        if (dxChart == null) {
            container.empty()
            if (ds.length == 0) {
                $("<div>(aucune vue)</div>").appendTo(container)
            } else {
                var series = [{
                    argumentField: 'dat',
                    valueField: 'nb',
                    type: 'line',
                }]
                var minDate = ds[0].dat

                dxChart = $("<div/>").appendTo(container).dxChart({
                    palette: "Soft",
                    dataSource: ds,
                    //height: "calc(100% - 120px)",
                    height: "100%",
                    commonSeriesSettings: {
                        point: {
                            size: 7,
                        },
                        aggregation: {
                            enabled: true,
                            method: "sum"
                        }
                    },
                    //argumentAxis: {
                    //    aggregationInterval: { hours:5}
                    //},
                    scrollBar: {
                        visible: true,
                    },
                    zoomAndPan: {
                        argumentAxis: 'both',
                    },
                    tooltip: {
                        enabled: true,
                        container: "body",
                        zIndex:99999999999,
                        location: 'edge',
                        customizeTooltip(arg) {
                            return {
                                text: arg.argument.toDDMMAA() + "<br/>" + arg.value + " vue" + ((arg.value > 1) ? "s" : ""),
                            };
                        },
                    },
                    series: series,
                    legend: {
                        visible: false,
                    },
                }).dxChart("instance");

                ////if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid] == 'undefined') {
                ////    option.bddCtrl.utiCourantParaJson[option.context_grid] = [new Date(parametre.dateNow).addMonths(-2), parametre.dateNow]
                ////} else {
                ////    var nbDay = Math.abs(diffdate(new Date(option.bddCtrl.utiCourantParaJson[option.context_grid][0]), new Date(option.bddCtrl.utiCourantParaJson[option.context_grid][1]), "d"))
                ////    option.bddCtrl.utiCourantParaJson[option.context_grid] = [new Date(maxDate).addDays(-nbDay), maxDate]
                ////}
                //dxZoom = $('<div/>').appendTo(container).dxRangeSelector({
                //    value: [ds[0].dat, ds[ds.length - 1].dat],
                //    size: {
                //        height: 120,
                //    },
                //    //scale: {
                //    //    minorTickCount: 1,
                //    //    minorTickInterval: 'day',
                //    //    tickInterval: 'day',
                //    //    minRange: 'week',
                //    //    maxRange: 'month',
                //    //},
                //    sliderMarker: {
                //        format: 'monthAndYear',
                //    },
                //    dataSource: ds,
                //    chart: {
                //        palette: "Soft",
                //        series: series
                //    },
                //    behavior: {
                //        valueChangeMode: 'onHandleMove',
                //    },
                //    onValueChanged(e) {
                //        //option.bddCtrl.utiCourantParaJson[option.context_grid] = e.value
                //        //option.bddCtrl.mSaveParaJsonUtilisateur();
                //        dxChart.getArgumentAxis().visualRange(e.value);
                //    },
                //}).dxRangeSelector("instance");
                ////dxChart.getArgumentAxis().visualRange([ds[0].dat, ds[ds.length-1].dat]);

                if (option.grid) { //dashboard
                    dxChart.element().on("mousedown", function (e) {
                        option.grid.enableMove(false);
                        option.grid.enableResize(false);
                    })
                    dxChart.element().on("mouseup", function (e) {
                        option.grid.enableMove(true);
                        option.grid.enableResize(true);
                    })
                    //dxChart.element().on("wheel mousewheel DOMMouseScroll'", function (e) {
                    //    e.stopPropagation()
                    //})
                    //container.on("wheel mousewheel DOMMouseScroll'", function (e) {
                    //    e.stopPropagation()
                    //})
                }
                oldDs = ds
            }
        } else {
            if (JSON.stringify(oldDs) != JSON.stringify(ds)) {
                dxChart.option("dataSource", ds)
                //dxZoom.option("dataSource", ds)
                oldDs = ds
            }
        }
    }

    this.mUpdate = function () {
        option.bddCtrl.mAjaxCall({ command: "gethistovue", id_table_com: option.idTableCom, id_com: option.idCom  }, function (data) {
            if (typeof data.lstvue == 'undefined') data.lstvue = []
            var maxDate = null
            data.lstvue.forEach(function (item) {
                item.nb = parseInt(item.nb)
                if (maxDate == null || maxDate < item.dat) maxDate = item.dat
            })
            mRempli(data.lstvue, maxDate)
        })
    }

    this.element = function () { return container }
    this.focus = function () { }

    mConstruit();
}